import { render, staticRenderFns } from "./BlogSearch.vue?vue&type=template&id=b885e4b0&scoped=true"
import script from "./BlogSearch.vue?vue&type=script&lang=js"
export * from "./BlogSearch.vue?vue&type=script&lang=js"
import style0 from "./BlogSearch.vue?vue&type=style&index=0&id=b885e4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885e4b0",
  null
  
)

export default component.exports